
// Hero.tsx (or Hero.jsx)

import React from 'react';
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section
      className="relative min-h-[100svh] flex items-end bg-black overflow-hidden"
      aria-label="MeVER メインビジュアル"
    >
      <div className="absolute inset-0">
        {/* PC用画像 */}
        <img
          src="https://public.readdy.ai/ai/img_res/37713ca32e118026f300d646f3faafb1.jpg"
          alt="MeVER Chair プロフェッショナルワークスペース"
          className="hidden md:block w-full h-full object-cover object-center opacity-60"
          loading="eager"
          fetchPriority="high"
          decoding="async"
          width="1920"
          height="1080"
        />
        {/* スマートフォン用画像 */}
        <img
          src="https://readdy.ai/api/search-image?query=young%20creative%20professional%20working%20at%20modern%20ergonomic%20desk%20setup%20with%20laptop%20and%20creative%20tools%20warm%20ambient%20lighting%20inspiring%20home%20office%20environment%20contemporary%20minimalist%20interior%20design%20professional%20photography%20focused%20work%20atmosphere%20stylish%20workspace%20aesthetic%20productive%20creative%20space%20natural%20composition&width=1080&height=1920&seq=hero-creator-workspace-mobile-001&orientation=portrait"
          alt="MeVER Chair プロフェッショナルワークスペース"
          className="block md:hidden w-full h-full object-cover object-center opacity-60"
          loading="eager"
          fetchPriority="high"
          decoding="async"
          width="1080"
          height="1920"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
      </div>

      <div className="relative z-10 w-full px-6 sm:px-10 lg:px-16 pb-16 sm:pb-20 lg:pb-24 pt-40">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 lg:gap-16">
          {/* Left: Text content */}
          <div className="flex-1 max-w-2xl">
            <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-extralight text-white mb-4 sm:mb-5 tracking-[0.08em] leading-[1.1]">
              Work &amp; Play
            </h1>
            <p className="text-base sm:text-lg md:text-xl font-extralight text-white/80 tracking-[0.08em] leading-relaxed">
              切り替えなんていらない。どちらも自分の人生だ。
            </p>
          </div>

          {/* Right: CTA buttons */}
          <div className="flex flex-col sm:flex-row lg:flex-col items-start sm:items-center lg:items-end gap-3 sm:gap-4 shrink-0">
            <a
              href="#products"
              className="w-full sm:w-auto px-8 sm:px-10 py-3.5 bg-white text-black text-sm font-normal tracking-[0.08em] hover:bg-white/90 transition-all whitespace-nowrap rounded-md cursor-pointer text-center"
              aria-label="製品セクションへスクロール"
            >
              製品を見る
            </a>
            <a
              href="https://tihhyh.readdy.co"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto px-8 sm:px-10 py-3.5 bg-white/10 backdrop-blur-sm text-white text-sm font-light tracking-[0.08em] hover:bg-white/20 transition-all whitespace-nowrap rounded-md border border-white/30 cursor-pointer text-center"
              aria-label="法人のお客様向けページを新しいタブで開く"
            >
              法人のお客様はこちら
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
